export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/environments/environment.ts